import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormGroup } from '@angular/forms';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { DBOperation } from '../../../shared/enum';

import { NgSelectComponent } from '@ng-select/ng-select';
import { Repository } from '../../../services/repository'


import 'jquery'
import 'bootstrap'

import {
  Lists_nguonkinhphi, Lists_nhacungcap, Lists_chuong, Lists_loaikhoan, Lists_tieumuc, Lists_canbo, Lists_caphat, Lists_nghiepvu, Lists_nganhang, Lists_hoatdong, Lists_cmmt, Lists_mathongke,
  congcus_dieuchuyencongcu, Lists_khachhang, Lists_khohang, Lists_congcudungcu, Lists_vattuhanghoa, Lists_phongban, Lists_nhommucchi, Lists_taisancodinh
} from '../../../routes/menu'



const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-dccongcuedit',
  templateUrl: './dccongcuedit.component.html',
  styleUrls: ['./dccongcuedit.component.scss'],
  providers: [ListService, Repository]
})


export class dccongcueditComponent implements OnInit {

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themdoituong: boolean = false;
  quyen_themnguon: boolean = false;
  quyen_themchuong: boolean = false;
  quyen_themkhoan: boolean = false;
  quyen_themtieumuc: boolean = false;
  quyen_themcapphat: boolean = false;
  quyen_themnghiepvu: boolean = false;
  quyen_themnganhang: boolean = false;
  quyen_themctmt: boolean = false;
  quyen_themhoatdong: boolean = false;
  quyen_themthongke: boolean = false;
  quyen_themnhommuchi: boolean = false;
  quyen_themvattuhanghoa: boolean = false;
  quyen_themtaisan: boolean = false;
  quyen_themcongcu: boolean = false;
  msg: string;
  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
  @ViewChild('mdDoiTuongNH', { static: false }) mdDoiTuongNH: ModalComponent;
  @ViewChild('mdCanBo', { static: false }) mdCanBo: ModalComponent;
  @ViewChild('mdKhachHang', { static: false }) mdKhachhang: ModalComponent;
  @ViewChild('mdLuaChon', { static: false }) mdLuaChon: ModalComponent;
  @ViewChild('mdTaiSan', { static: false }) mdTaiSan: ModalComponent;
  @ViewChild('modalVatTu', { static: false }) modalVatTu: ModalComponent;
  @ViewChild('slKhachHang', { static: false }) slKhachHang: NgSelectComponent;
  @ViewChild('slTaiKhoanNo', { static: false }) slTaiKhoanNo: NgSelectComponent;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  @ViewChild('dtevattu', { static: false }) dtevattu: any;
  @ViewChild('dtetaisan', { static: false }) taisanedit: any;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('dtenganhang', { static: false }) nganhangedit: any;
  @ViewChild('dteCanBo', { static: false }) canboedit: any;
  @ViewChild('dteKhachHang', { static: false }) khachhangedit: any;
  @ViewChild("diengiaitxt", { static: false }) diengiaitxt: ElementRef;
  datas: Idata[];
  data: Idata;
  indLoading: boolean = false;
  dataFrm: FormGroup;
  dbops: DBOperation;
  modalTitle: string;
  modalBtnTitle: string;
  inputtaikhoans: any;
  inputkhachhangs: any;
  inputnguonkinhphis: any;
  inputchuongs: any;
  inputcaphats: any;
  inputnghiepvus: any;
  inputnganhangs: any;
  inputhoatdongs: any;
  inputcmmts: any;
  inputthongkes: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputlienquans: any;
  inputtaisans: any;
  inputhanghoas: any;
  inputhangcongcus: any;
  inputkhohangs: any;
  inputPhongBans: any;

  public ngaychungtu: Date = new Date();
  public ngayghiso: Date = new Date();
  taikhoanno: any = null;
  tendoituong: any = null;

  tabselected: number = 1;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  @Output() save: EventEmitter<any> = new EventEmitter();
  isHidden: number = 0;
  public loading = true;
  //----------tham số các nhóm cột------------------
  nhomnguonid: string = Lists_nguonkinhphi.id;
  nhomchuongid: string = Lists_chuong.id;
  nhomloaikhoanid: string = Lists_loaikhoan.id;
  nhomtieumucid: string = Lists_tieumuc.id;
  hinhthuccapphatid: string = Lists_caphat.id;
  nghiepvuid: string = Lists_nghiepvu.id;
  nganhangid: string = Lists_nganhang.id;
  hoatdongid: string = Lists_hoatdong.id;
  cmmtid: string = Lists_cmmt.id;
  mathongke: string = Lists_mathongke.id;
  congcuid: string = Lists_congcudungcu.id;
  phongbanid: string = Lists_phongban.id;

  //-----------------------------------------------------

  chungtuSelect: any = {
    Id: null, Don_Vi_Id: null, Ho_Ten: null, Doi_Tuong_Id: null,
    Phan_He_Id: null, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
    SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
    CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null,
    ChiTiets: [], DongThois: []
  };
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  public ngxSLOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 2,
    allowNegative: false
  };

  donviid: string = null;
  namketoan: number;
  username: string = null;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private repo: Repository) {



  }
  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent): void {
    if ((event.altKey || event.metaKey) && event.keyCode == 49) {
      this.tabselected = 1;

      setTimeout(() => {
        this.setComboFocus(0, 1, 1);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 50) {
      this.tabselected = 2;
      setTimeout(() => {
        this.setComboFocus(0, 1, 2);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 51) {
      this.tabselected = 3;
      setTimeout(() => {
        this.setComboFocus(0, 1, 3);
      }, 500);
    }
    event.stopPropagation();

  }
  phanheid: string = null;
  titlevattu: string = null;
  public innerHeight: any;
  //id--ichung tu; loai: đánh dấu trường hợp copy (1: copy, 0: ko)
  loadDataInit(id: string, loai: number, pheid: string, ctu: any) {
    this.innerHeight = window.innerHeight - 250;
    this.ngaychungtu = new Date();
    this.ngayghiso = new Date();
    this.tabselected = 1;
    this.phanheid = pheid;
    //----------------------lây thông tin ban đầu

    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
      var giatri = crru.ds_quyen.filter(name => name.id === this.phanheid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
      // gán quyền thêm đối tượng
      var giatri1 = crru.ds_quyen.filter(name => name.id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themdoituong = true;
        else
          this.quyen_themdoituong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nguonkinhphi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnguon = true;
        else
          this.quyen_themnguon = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_chuong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themchuong = true;
        else
          this.quyen_themchuong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_loaikhoan.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themkhoan = true;
        else
          this.quyen_themkhoan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_tieumuc.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtieumuc = true;
        else
          this.quyen_themtieumuc = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_caphat.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcapphat = true;
        else
          this.quyen_themcapphat = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nghiepvu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnghiepvu = true;
        else
          this.quyen_themnghiepvu = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nganhang.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnganhang = true;
        else
          this.quyen_themnganhang = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_cmmt.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themctmt = true;
        else
          this.quyen_themctmt = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_hoatdong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themhoatdong = true;
        else
          this.quyen_themhoatdong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_mathongke.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themthongke = true;
        else
          this.quyen_themthongke = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nhommucchi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnhommuchi = true;
        else
          this.quyen_themnhommuchi = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_vattuhanghoa.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themvattuhanghoa = true;
        else
          this.quyen_themvattuhanghoa = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_taisancodinh.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaisan = true;
        else
          this.quyen_themtaisan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_congcudungcu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcongcu = true;
        else
          this.quyen_themcongcu = false;
      }



    }
    //--------kiểm tra hiển thị công cụ hay hàng hóa---------------------------------
    if (this.phanheid.toLowerCase() === congcus_dieuchuyencongcu.id.toLowerCase()) {
      this.titlevattu = "Công cụ";
      this.inputhangcongcus = this.inputtaisans;
      this.congcuid = Lists_congcudungcu.id;
    }
    else {
      this.congcuid = Lists_vattuhanghoa.id;
      this.titlevattu = "Hàng hóa";
      this.inputhangcongcus = this.inputhanghoas;
    }


    //------------------------------------------
    this.chungtuSelect = {
      Id: null, Don_Vi_Id: this.donviid, Ho_Ten: null, Doi_Tuong_Id: null,
      Phan_He_Id: this.phanheid, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
      SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
      CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null,
      ChiTiets: [], DongThois: []
    };

    if (id === null) {

      if (ctu === null)
        this.AddRowNew(this.chungtuSelect.ChiTiets);
      else {
        this.chungtuSelect = ctu;
      }
      if (ctu === null || ctu.Ma_Lien_Quan === null || ctu.Ma_Lien_Quan === "") {
        if (ctu !== null) {
          this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
          this.chungtuSelect.Lien_Quan_Id = ctu.Id;
          this.isHidden = 3;
        }
        this.chungtuSelect.Id = null;
        //{ id: this.donviid, chuoi: tiens_phieuthu.id, status: '2019' }
        this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan })
          .subscribe(response => {
            //console.log(response[0].Column1);
            if (response != null)
              this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;

            this.loading = false;
          });
      }
      else //trường hợp sửa lại chứng từ phiếu thu từ phiếu rút tiền dự toán
      {
        this.isHidden = 3;
        var m_lienquan = this.chungtuSelect.Ma_Lien_Quan;
        var i_lienquan = this.chungtuSelect.Lien_Quan_Id;
        this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
        this.chungtuSelect.Lien_Quan_Id = ctu.Id;

        this.chungtuSelect.Ma_Chung_Tu = m_lienquan;
        this.chungtuSelect.Id = i_lienquan;
        this.loading = false;
      }
    }
    else {
      this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: id, status: loai })
        .subscribe(response => {
          console.log(response);
          this.chungtuSelect = response;
          if (this.chungtuSelect.Ma_Lien_Quan !== null && this.chungtuSelect.Ma_Lien_Quan !== "") {
            this.isHidden = 3;
          }
          else
            this.isHidden = 0;

          if (loai === 1) {
            let idcopy = this.chungtuSelect.Id;
            this.chungtuSelect.Id = null;
            this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan, Chuoi4: idcopy })
              .subscribe(response => {
                //console.log(response[0].Column1);
                if (response != null)
                  this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;

                this.loading = false;
              });
          }
          else
            this.loading = false;
          this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Chung_Tu);
          this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);
        });
    }


    setTimeout(() => {
      this.diengiaitxt.nativeElement.focus();
    }, 1000);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: this.namketoan, DonViId: this.donviid, UserName: this.username })
      .subscribe(response => {
        this.inputtaikhoans = response;
      });
    this.LoadCategory();

  }


  LoadCategory(): void {
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_phongban.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputPhongBans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_khohang.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputkhohangs = response;
      });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_hoatdong.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputhoatdongs = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_cmmt.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputcmmts = response;
    //  });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_mathongke.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputthongkes = response;
      });

    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_vattuhanghoa.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputhanghoas = response;
    //  });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_congcudungcu.id, MaGiaoDien: '', DonViId: this.donviid, NamKeToan: this.namketoan })
      .subscribe(response => {
        this.inputtaisans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_chuong.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputchuongs = response;
      });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_caphat.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputcaphats = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nghiepvu.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputnghiepvus = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nganhang.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputnganhangs = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: '532A61EA-D765-844B-8CBF-E610B209E332', MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputkhachhangs = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nguonkinhphi.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputnguonkinhphis = response;
    //  });

    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputloaikhoans = response;
    //  });
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputtieumucs = response;
    //  });
  }

  @ViewChildren("myinput") divs: QueryList<ElementRef>;


  selectedTab(tab: number) {
    this.tabselected = tab;
    setTimeout(() => {
      this.setComboFocus(0, 1, tab);
    }, 500);
  }
  //----------event xử lý di chuyển Enter--------------------------------------
  public changeSLDG(drow: any) {
    drow.So_Tien = drow.Don_Gia * drow.So_Luong;
  }
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;
    //if (cot === 6 && luoi === 1) //---------so luong, don gia
    //{
    //  var row = this.chungtuSelect.ChiTiets[hang];
    //  this.layGiaHang(row);
    //}

    if ((cot === 4 || cot === 5) && luoi === 1) //---------so luong, don gia
    {
      var row = this.chungtuSelect.ChiTiets[hang];
      row.So_Tien = row.Don_Gia * row.So_Luong;
    }

    var ketqua = false;
    this.slcombo.forEach(
      (question, i, allQuestions) => {
        if (question.labelForId === tencombo) {
          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
  keyLyDo(event: any) {
    if (event.which === 13) {
      //this.slTaiKhoanNo.focus();
      this.setComboFocus(0, 1, 1);
      event.preventDefault();
    }
  }
  keyTKNoPress(event: any) {
    if (event.which === 13) {
      this.setComboFocus(0, 1, 1);
      event.preventDefault();
    }
  }
  maxcot: number = 8;

  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {

    if (luoi === 2)
      this.maxcot = 7;
    if (luoi === 1)
      this.maxcot = 8;
    if (luoi === 3)
      this.maxcot = 13;
    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;

        if (luoi === 3) {
          if (hang === this.chungtuSelect.DongThois.length) {
            this.AddRowNew(this.chungtuSelect.DongThois);
          }
        }
        else {
          if (hang === this.chungtuSelect.ChiTiets.length) {
            this.AddRowNew(this.chungtuSelect.ChiTiets);
          }
        }
      }
      this.setComboFocus(hang, cot, luoi);
      event.preventDefault();
    }
  }
  RowNewClick() {
    if (this.tabselected === 3) {
      this.AddRowNew(this.chungtuSelect.DongThois);
    }
    else
      this.AddRowNew(this.chungtuSelect.ChiTiets);
  }
  AddRowKep(index: string, luoi: number) {
    var row = this.chungtuSelect.ChiTiets[index];
    var sp = 'bottom';
    if (this.chungtuSelect.DongThois.length > 9)
      sp = 'top'
    this.chungtuSelect.DongThois.push({
      showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: null, So_Tien: row.So_Tien,
      Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
      Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id
    });
    this.tabselected = 3;
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: row.Tai_Khoan_No_Id, Tai_Khoan_Co_Id: row.Tai_Khoan_Co_Id, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: null,
        Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
        Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: null, NgayCTG: null, Dien_Giai_Chi_Tiet: null, So_Tien: null,
        Nguon_Id: null, Chuong_Id: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null, Hinh_Thuc_Cap_Phat_Id: null, Nghiep_Vu_Id: null,
        Ngan_Hang_Id: null, Ma_Thong_Ke_Id: null, CTMT_Id: null, Hoat_Dong_Id: null
      });

    }

  }
  //----------event các control------------------------------------------------------
  onLienQuanChange($event) {

    console.log($event)
    if (typeof $event !== "undefined") {
      this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: $event.Id })
        .subscribe(response => {
          console.log(response);
          response.Ma_Chung_Tu = this.chungtuSelect.Ma_Chung_Tu;
          response.Lien_Quan_Id = response.Id;
          this.chungtuSelect = response;
          this.chungtuSelect.Id = null;
          this.chungtuSelect.Phan_He_Id = this.phanheid;
          this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Chung_Tu);
          this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);

        });
    }
  }
  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.chungtuSelect.Ten_Doi_Tuong = null;
    }
    else
      this.chungtuSelect.Ten_Doi_Tuong = $event.Ten_Doi_Tuong;
  }
  onTaiSanChange($event, hang: number) {

    var rs = this.chungtuSelect.ChiTiets[hang];

    if (typeof $event === "undefined") {
      rs.Dien_Giai_Chi_Tiet = null;
    }
    else {
      rs.Dien_Giai_Chi_Tiet = $event.Ten_Doi_Tuong;
      //this.layGiaHang(rs);
      this.repo.postRequest('api/cauhinhdongthoi/laythongtinccdc', { DonViId: this.donviid, Id: $event.Id, DenNgay: this.ngayghiso, LienQuanId: rs.Id, PhanHeId: this.phanheid })
        .subscribe(response => {
          let soluong = 0, dongia = 0;
          if (response != null) {
            soluong = response[0].So_Luong;
            dongia = response[0].Don_Gia;
          }

          if (soluong > 0) {
            rs.So_Luong = soluong;
            rs.Don_Gia = dongia;
            rs.So_Tien = soluong * dongia;
            rs.Doi_Tuong_Id_1 = response[0].Phong_Ban_Id;
          }

        });

    }
  }
  onKhoHangChange($event, hang: number) {
    var rs = this.chungtuSelect.ChiTiets[hang];

    if (typeof $event !== "undefined") {
      this.layGiaHang(rs);
    }
  }
  layGiaHang(row: any) {
    if (row.Kho_Hang_Id !== null && row.Hang_Hoa_Id !== null && row.So_Luong !== null && parseInt(row.So_Luong, 10) > 0) {
      var ngayhtoan = (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getDate() + '/' + this.ngayghiso.getFullYear();
      this.repo.postRequest('api/doituong/tinhgiafifo3', { NgayHachToan: ngayhtoan, Kho_Hang_Id_Co: row.Kho_Hang_Id, Hang_Hoa_Id_Co: row.Hang_Hoa_Id, Id: this.chungtuSelect.Id, TaiKhoan: row.Tai_Khoan_Co_Id, SoLuong: row.So_Luong, DonViId: this.donviid })
        .subscribe(response => {
          console.log(response);
          if (response[0].Gia_Xuat > 0) {
            row.So_Luong = response[0].So_Luong_Xuat;
          }
          row.So_Tien = response[0].Gia_Xuat;
          row.Don_Gia = row.So_Tien / row.So_Luong;

        });
    }

  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFnTKS(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Tai_Khoan.toLowerCase().startsWith(term);
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent, hang: number, cot: number) {

    this.comboSeleted = cobo;
    console.log(cobo)

    cobo.close();
    this.rowSelected = this.chungtuSelect.ChiTiets[hang];
    if (cobo.addTagText.toLowerCase() === Lists_nganhang.id.toLowerCase()) {
      this.nganhangedit.loadDataInit(cobo.addTagText, null, this.donviid, cot);
      this.mdDoiTuongNH.open();
    }
    else if (cobo.addTagText.toLowerCase() === Lists_congcudungcu.id.toLowerCase()) {

      this.taisanedit.loadDataInit(cobo.addTagText, null, this.donviid, cot);
      this.mdTaiSan.open();
    }
    else if (cobo.addTagText.toLowerCase() === Lists_phongban.id.toLowerCase()) {
      this.dtevattu.loadDataInit(cobo.addTagText, null, this.donviid, cot);
      this.modalVatTu.open();
    }
    else {
      this.doituongchungedit.loadDataInit(cobo.addTagText, null, this.donviid);
      this.mdDoiTuongChung.open();
    }


  }
  AddNguoiNop(cobo: NgSelectComponent) {
    this.comboSeleted = cobo;
    cobo.close();
    this.mdLuaChon.open();
  }
  loaithem: number = 2;
  onLoaiNguoiNop(loai: number) {
    this.loaithem = loai;
    console.log(loai);
  }
  AddFormNguoiNop() {
    this.mdLuaChon.dismiss();
    if (this.loaithem === 2) {
      this.canboedit.loadDataInit(Lists_canbo.id, null, this.donviid);
      this.mdCanBo.open();
    }
    else if (this.loaithem === 3) {
      this.khachhangedit.loadDataInit(Lists_khachhang.id, null, this.donviid);
      this.mdKhachhang.open();
    }
    else {
      this.khachhangedit.loadDataInit(Lists_nhacungcap.id, null, this.donviid);
      this.mdKhachhang.open();
    }
  }
  //------------------------------------
  saveModalKhacHang(doituong: any) {
    this.mdKhachhang.dismiss();

    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();

    this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
    this.tendoituong = doituong.Ten_Doi_Tuong;
  }
  saveModalCanBo(doituong: any) {
    this.mdCanBo.dismiss();
    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();

    this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
    this.tendoituong = doituong.Ten_Doi_Tuong;
  }
  saveModalNganHang(doituong: any) {
    this.mdDoiTuongNH.dismiss();
    this.inputnganhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputnganhangs = this.inputnganhangs.slice();

    this.rowSelected.Ngan_Hang_Id = doituong.Id;
  }
  saveModalTaiSan(doituong: any) {
    this.mdTaiSan.dismiss();
    this.inputtaisans.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputtaisans = this.inputtaisans.slice();

    this.inputhangcongcus = this.inputtaisans;

    this.rowSelected.Hang_Hoa_Id = doituong.Id;
    this.rowSelected.Dien_Giai_Chi_Tiet = doituong.Ten_Doi_Tuong;
  }
  saveModalPhongBan(doituong: any) {
    this.modalVatTu.dismiss();
    this.inputPhongBans.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputPhongBans = this.inputPhongBans.slice();
    if (doituong.CallForm==6)   
      this.rowSelected.Doi_Tuong_Id_1 = doituong.Id;
    else
      this.rowSelected.Doi_Tuong_Id_12 = doituong.Id;
    
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();

    if (doituong != null && Lists_hoatdong.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputhoatdongs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputhoatdongs = this.inputhoatdongs.slice();
      this.rowSelected.Hoat_Dong_Id = doituong.Id;
    }
    if (doituong != null && Lists_cmmt.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputcmmts.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputcmmts = this.inputcmmts.slice();
      this.rowSelected.CTMT_Id = doituong.Id;
    }
    if (doituong != null && Lists_mathongke.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputthongkes.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputthongkes = this.inputthongkes.slice();
      this.rowSelected.Ma_Thong_Ke_Id = doituong.Id;
    }
    if (doituong != null && Lists_caphat.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputcaphats.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputcaphats = this.inputcaphats.slice();
      this.rowSelected.Hinh_Thuc_Cap_Phat_Id = doituong.Id;
    }
    if (doituong != null && Lists_nghiepvu.id === doituong.Nhom_Doi_Tuong_ID) {

      this.inputnghiepvus.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputnghiepvus = this.inputnghiepvus.slice();

      this.rowSelected.Nghiep_Vu_Id = doituong.Id;
    }
    if (doituong != null && this.nhomnguonid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputnguonkinhphis.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputnguonkinhphis = this.inputnguonkinhphis.slice();

      this.rowSelected.Nguon_Id = doituong.Id;
    }
    if (doituong != null && this.nhomloaikhoanid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputloaikhoans.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputloaikhoans = this.inputloaikhoans.slice();
      this.rowSelected.Loai_Khoan_Id = doituong.Id;
    }
    if (doituong != null && this.nhomchuongid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputchuongs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputchuongs = this.inputchuongs.slice();
      this.rowSelected.Chuong_Id = doituong.Id;
    }
    if (doituong != null && this.nhomtieumucid === doituong.Nhom_Doi_Tuong_ID) {

      this.inputtieumucs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      this.inputtieumucs = this.inputtieumucs.slice();
      this.rowSelected.Tieu_Muc_Id = doituong.Id;
    }
    this.comboSeleted.focus();
  }
  deleterow(index: string) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.chungtuSelect.ChiTiets.splice(index, 1);
        }
      });


  }
  public savectu() {


    //if (this.namketoan !== this.ngayghiso.getFullYear()) {
    //  swal('Cảnh báo!', "Ngày hạch toán nằm ngoài năm kế toán!!!", 'warning');
    //  return;
    //}
    if (this.chungtuSelect.Dien_Giai === null || this.chungtuSelect.Dien_Giai === '') {
      swal('Cảnh báo!', "Bạn chưa nhập diễn giải", 'warning');
      return;
    }

    for (let i = 0; i < this.chungtuSelect.ChiTiets.length; i++) {
      var row = this.chungtuSelect.ChiTiets[i];
      if (!this.datecheck(row.NgayCTG)) {
        swal('Cảnh báo!', "Ngày chứng từ gốc không hợp lệ", 'warning');
        this.setComboFocus(i, 4, 1);
        return;
      }
    }

    this.chungtuSelect.Ngay_Ghi_So_S = this.ngayghiso.getDate() + '/' + (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getFullYear();
    this.chungtuSelect.Ngay_Chung_Tu_S = this.ngaychungtu.getDate() + '/' + (this.ngaychungtu.getMonth() + 1) + '/' + this.ngaychungtu.getFullYear();
    $('#loading').show();
    this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
      .subscribe(response => {
        console.log(response);
        $('#loading').hide();
        if (response.Status === "OK")
          this.save.emit(this.chungtuSelect);
        else
          swal('Cảnh báo!', response.Status, 'warning');
      });

  }
  closeModal() {
    this.save.emit(null);
  }
  //-------------ham tiện ích---------------------------------------
  datecheck(conformedValue) {
    if (conformedValue == null || conformedValue === "")
      return true;
    const maxValueMonth = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    const formatOrder = ['yyyy', 'yy', 'mm', 'dd', 'HH', 'MM', 'SS']
    var dateFormat: String = 'dd/mm/yyyy';
    var maxYear: number = 9999
    var minYear: number = 1;
    const dateFormatArray = dateFormat.split(/[^dmyHMS]+/).sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b))

    const indexesOfPipedChars = []
    const maxValue = { 'dd': 31, 'mm': 12, 'yy': 99, 'yyyy': maxYear, 'HH': 23, 'MM': 59, 'SS': 59 }
    const minValue = { 'dd': 1, 'mm': 1, 'yy': 0, 'yyyy': minYear, 'HH': 0, 'MM': 0, 'SS': 0 }
    const conformedValueArr = conformedValue.split('')

    // Check first digit
    dateFormatArray.forEach((format) => {
      const position = dateFormat.indexOf(format)
      const maxFirstDigit = parseInt(maxValue[format].toString().substr(0, 1), 10)

      if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
        conformedValueArr[position + 1] = conformedValueArr[position]
        conformedValueArr[position] = 0
        indexesOfPipedChars.push(position)
      }
    })

    // Check for invalid date
    let month = 0
    const isInvalid = dateFormatArray.some((format) => {
      const position = dateFormat.indexOf(format)
      const length = format.length
      const textValue = conformedValue.substr(position, length).replace(/\D/g, '')
      const value = parseInt(textValue, 10)
      if (format === 'mm') {
        month = value || 0
      }
      const maxValueForFormat = format === 'dd' ? maxValueMonth[month] : maxValue[format]
      if (format === 'yyyy' && (minYear !== 1 || maxYear !== 9999)) {
        const scopedMaxValue = parseInt(maxValue[format].toString().substring(0, textValue.length), 10)
        const scopedMinValue = parseInt(minValue[format].toString().substring(0, textValue.length), 10)
        return value < scopedMinValue || value > scopedMaxValue
      }
      return value > maxValueForFormat || (textValue.length === length && value < minValue[format])
    })

    if (isInvalid) {
      return false
    }

    return true;
  }



}
export interface Idata {
  Id: string,
  Ten: string,
  Dien_Thoai: string,
  Dia_Chi: string,
  Email: string,
  GhiChu: string,
  Created: Date,
  CreatedBy: string,
  Modified: Date,
  ModifiedBy: string
}
